var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vi-button",class:{'isClear':_vm.isClear}},[_c('button',{staticClass:"button"},[_vm._v(_vm._s(_vm.buttonLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }